exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-input-wrapper[data-v-5a9482e6] .input-group--text-field__suffix{font-size:.95em}@media screen and (max-width:660px){.search-input-wrapper[data-v-5a9482e6] .input-group--text-field__suffix{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5a9482e6","scoped":true,"sourceMap":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/header/SearchList.vue
// module id = 1039
// module chunks = 22